export default {"src":"https://assets.madeeasy.in/non-prod/_next/static/media/bookmark_fill.a5ffc260.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};